module.exports = __webpack_public_path__ + "static/space-measure-do-f14f559d7c2f4e5feb74f2b133ded1bb.png";